var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonalLoanIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_9095_22582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z",
    fill: "#FFB30E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3348 9.77734C16.3078 9.77734 14.6582 11.427 14.6582 13.4539C14.6582 15.4809 16.307 17.1305 18.3348 17.1305C20.3625 17.1305 22.0113 15.4809 22.0113 13.4539C22.0113 11.427 20.3625 9.77734 18.3348 9.77734ZM18.1355 13.06H18.5349C19.1486 13.06 19.648 13.5595 19.648 14.1732C19.648 14.7254 19.2502 15.1792 18.7287 15.2721V15.6857C18.7287 15.9031 18.5522 16.0796 18.3348 16.0796C18.1173 16.0796 17.9409 15.9031 17.9409 15.6857V15.2918H17.4154C17.198 15.2918 17.0215 15.1153 17.0215 14.8979C17.0215 14.6805 17.198 14.504 17.4154 14.504H18.5341C18.7137 14.504 18.8602 14.3575 18.8602 14.1787C18.8602 13.9943 18.7137 13.8478 18.5349 13.8478H18.1355C17.5218 13.8478 17.0223 13.3484 17.0223 12.7347C17.0223 12.1824 17.4202 11.7287 17.9417 11.6357V11.2213C17.9417 11.0039 18.1181 10.8275 18.3356 10.8275C18.553 10.8275 18.7295 11.0039 18.7295 11.2213V11.6152H19.2541C19.4715 11.6152 19.648 11.7917 19.648 12.0091C19.648 12.2266 19.4715 12.403 19.2541 12.403H18.1355C17.9559 12.403 17.8101 12.5495 17.8101 12.7284C17.8101 12.9135 17.9559 13.06 18.1355 13.06Z",
    fill: "#FFF2D5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0175 16.0011C9.88426 16.0042 9.77734 16.1193 9.77734 16.2609V20.9268C9.77734 21.0699 9.88645 21.1858 10.0212 21.1858H11.0574C11.1665 21.1858 11.2624 21.1088 11.2924 20.9976L12.3725 16.9539C12.4421 16.6925 12.3103 16.418 12.0701 16.3254C11.6278 16.1535 10.949 15.9848 10.0175 16.0011Z",
    fill: "#FFF2D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5188 18.8532C19.5427 18.8532 17.5897 20.1661 16.6136 20.1661C15.6375 20.1661 14.5383 19.3712 14.5383 19.3712C14.5383 19.3712 15.8535 19.6302 16.6128 19.6302C17.3722 19.6302 17.589 19.3549 17.589 18.9823C17.589 18.0746 16.1376 17.9339 15.4039 17.8156C14.6833 17.3894 14.3091 17.0526 13.1155 16.9453C13.1082 17.0192 13.0972 17.0923 13.0782 17.1662L12.0977 20.8373C13.2085 21.3732 15.1212 22.2233 16.1251 22.2233C17.5897 22.2233 21.4949 20.149 21.4949 19.631C21.4949 19.1122 21.0065 18.8532 20.5188 18.8532Z",
    fill: "#FFF2D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_9095_22582",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9095_22582"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalLoanIcon);
export default __webpack_public_path__ + "static/media/personal_loan_icon.39cdf664a0d13b590fd15ec69f1f0f7c.svg";
export { ForwardRef as ReactComponent };